
































































































































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';

import { statesList } from '@/utils/Utils';

// Components
import SelectField from '@/components/Form/SelectField.vue';
import TextField from '@/components/Form/TextField.vue';
import RadioField from '@/components/Form/RadioField.vue';

@Component({
	name: 'PrimaryContactForThisEventorClaimFields',
	components: {
		SelectField,
		TextField,
		RadioField,
	},
})
export default class PrimaryContactForThisEventorClaim extends Vue {
	@Prop() private values: any;
	@Prop() private input: any;
	@Prop() private blur: any;
	@Prop() private errors: any;
	@Prop() private touched: any;

	private statesList: typeof statesList = statesList;

	@State('policies', { namespace: 'Policy' }) private policies: any;

	get sameAsContacts() {
		const contactList = [];
		if (
			this.values.insuredsPolicyInformation.reportingForAAN === 'Both' ||
			this.values.insuredsPolicyInformation.reportingForAAN === 'Group'
		) {
			if (this.values.involvedInsuredsHealthCareProviders.group.groupName !== '') {
				contactList.push({
					id: 'group',
					name:
						'Entity - ' +
						this.values.involvedInsuredsHealthCareProviders.group.groupName +
						' | ' +
						this.values.involvedInsuredsHealthCareProviders.group.phonePreference +
						' - ' +
						this.values.involvedInsuredsHealthCareProviders.group.phoneNumber +
						' | ' +
						this.values.involvedInsuredsHealthCareProviders.group.emailAddress,
				});
			} else if (this.values.involvedInsuredsHealthCareProviders.group.sameContactAs) {
				contactList.push(
					this.values.involvedInsuredsHealthCareProviders.group.sameContactAs,
				);
			}
		}

		if (
			this.values.insuredsPolicyInformation.reportingForAAN === 'Both' ||
			this.values.insuredsPolicyInformation.reportingForAAN === 'Individual'
		) {
			this.values.involvedInsuredsHealthCareProviders.providers.forEach((provider, index) => {
				if (provider.firstName !== '' && !provider.sameContactAs) {
					contactList.push({
						id: 'provider' + index,
						name:
							'Provider ' +
							(index + 1) +
							' - ' +
							provider.firstName +
							' ' +
							provider.lastName +
							' | ' +
							provider.phonePreference +
							' - ' +
							provider.phoneNumber +
							' | ' +
							provider.emailAddress,
					});
				} else if (provider.sameContactAs) {
					contactList.push(provider.sameContactAs);
				}
			});
		}

		return contactList;
	}
}
